import React from 'react'
import ReactMarkdown from 'react-markdown'
import rehypeSlug from 'rehype-slug'
import remarkGfm from 'remark-gfm'

interface MarkdownProps {
  children: string
}

const Markdown = ({ children }: MarkdownProps) => (
  <ReactMarkdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeSlug]}>
    {children}
  </ReactMarkdown>
)

export default Markdown
